import * as React from 'react';

/**
 * @description TimeDotted icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { TimeDotted } from '@sravni/design-system-icons'
 *
 * <TimeDotted />
 * ```
 */
const TimeDotted = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "TimeDotted", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M11.194 2.556c3.546.596 6.25 3.672 6.25 7.387a7.5 7.5 0 0 1-7.5 7.5c-3.715 0-6.792-2.704-7.387-6.25M2.556 8.694c.079-.47.201-.925.364-1.362M5.164 4.165c-.364.3-.698.635-1 1M8.694 2.556c-.47.079-.926.202-1.362.365", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.326 5.833v4.493h-3.66", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { TimeDotted };
//# sourceMappingURL=TimeDotted.js.map
